// @ts-nocheck
import { PreferencesReceiptsBoot } from './PreferencesReceiptsFormBoot';
import { PreferencesReceiptsFormPage } from './PreferencesReceiptsFormPage';

/**
 * Preferences - Receipts.
 */
export function PreferencesReceipts() {
  return (
    <PreferencesReceiptsBoot>
      <PreferencesReceiptsFormPage />
    </PreferencesReceiptsBoot>
  );
}
